<template>
  <div id="app">
    <layout v-if="isPreloadDone">
      <div
        class="snow-holder"
        :class="{ hidden: !isSnowHolderVisible }"
        ref="snowHolder"
      ></div>

      <app-header />

      <center-container>
        <div class="container-slider-h">
          <carousel v-bind="carouselProps" @change="onSlotChange" ref="carousel">
            <template v-slot:[`left-${i}`] v-for="i in carouselProps.slotCount">
              <div :key="i">
                <div
                    :is="getSlide(i - 1, 'left')"
                    @pause="stopTransition"
                    @start-next="startTransition(i - 1)"
                ></div>
              </div>
            </template>
            <template v-slot:[`right-${i}`] v-for="i in carouselProps.slotCount">
              <div :key="i">
                <div
                    :is="getSlide(i - 1, 'right')"
                    :is-active="activeSlot === i - 1"
                    @play-video="openVideoPopup"
                ></div>
              </div>
            </template>
          </carousel>
          <counter-marks
              :count="carouselProps.slotCount"
              :active="activeSlot"
              class="counter-marks tablet"
              @click="changeSlot"
          />
        </div>

        <legal-text />
      </center-container>

      <counter-marks
        :count="carouselProps.slotCount"
        :active="activeSlot"
        class="counter-marks"
        @click="changeSlot"
      />
      <video-popup
        v-if="isVideoPopupOpened"
        :videoSrc="videoSrc"
        @close="closeVideoPopup"
      />
    </layout>
    <preloader :time="preloadeTime" v-else />
  </div>
</template>

<script>
  import Preloader from './components/Preloader.vue';
  import Layout from './components/Layout.vue';
  import AppHeader from './components/AppHeader.vue';
  import CenterContainer from './components/CenterContainer.vue';
  import Carousel from './components/Carousel.vue';
  import CounterMarks from './components/CounterMarks/CounterMarks.vue';

  import { getCount, getSlide } from './components/SlideFragment';

  import snowHandler from './components/SlideFragment/slideComponents/snow-handler';
  import VideoPopup from './components/VideoPopup.vue';

  import LegalText from './components/LegalText.vue'

  export default {
    name: 'app',
    components: {
      Layout,
      AppHeader,
      CenterContainer,
      Carousel,
      CounterMarks,
      Preloader,
      VideoPopup,
      LegalText
    },
    data() {
      return {
        preloadeTime: 3000,
        isPreloadDone: false,
        carouselProps: {
          slotCount: getCount(),
          interval: 6000
        },
        getSlide,
        activeSlot: 0,
        isVideoPopupOpened: false,
        videoSrc: null
      };
    },
    mounted() {
      if (!this.isMSIEBrowser()) {
        setTimeout(() => {
          this.isPreloadDone = true;
          this.$nextTick(() => snowHandler(this.$refs.snowHolder));
        }, this.preloadeTime);
      }
    },
    computed: {
      isSnowHolderVisible() {
        return this.activeSlot === 0;
      }
    },
    methods: {
      isMSIEBrowser() {
        const msie = window.navigator.userAgent.indexOf('MSIE ');
        return msie > 0;
      },
      onSlotChange(index) {
        this.activeSlot = index;
      },
      stopTransition() {
        this.$refs.carousel.stopTransition();
      },
      startTransition(index) {
        this.stopTransition();
        this.$refs.carousel.startTransition(index);
      },
      changeSlot(i) {
        if (!this.$refs.carousel.isActiveChangeAnimation) {
          this.$refs.carousel.forceChangeSlot(i);
        }
      },
      openVideoPopup(videoSrc) {
        this.stopTransition();

        this.videoSrc = videoSrc;
        this.isVideoPopupOpened = true;
      },
      closeVideoPopup() {
        this.isVideoPopupOpened = false;
        this.videoSrc = null;

        this.changeSlot();
      }
    }
  };
</script>

<style lang="scss">
  @import '~styles/scss/media.scss';
  @import '~styles/scss/fonts.scss';

  html,
  body,
  #app {
    margin: 0;
    padding: 0;
    max-width: 100vw;
    overflow-x: hidden;
  }
  #app {
    font: 400 normal 22px/34px ProximaNova;
    background: #040913;
    position: relative;
  }

  .counter-marks {
    position: absolute;
    margin-top: 185px;
    top: 174px;
    z-index: 35;

    @include respond-to(medium) {
      top: 54px;
    }
    @include respond-to(tabletRotate) {
      display: none;
    }

    &.tablet {
      display: none;
      @include respond-to(tabletRotate) {
        display: block;
        position: static;
        top: 0;
        width: 100%;
        height: 33px;
        margin: 50px auto 20px auto;
        max-width: 248px;
      }
    }
    @media screen and (max-height: 640px) and (min-width: 991px) {
      margin-top: 70px;
    }
    @media screen and (max-height: 930px) and (min-width: 1260px) and (max-width: 1920px) and (max-height: 41.1vw) {
      top: 100px;
    }
    @media screen and (min-height: 676px) and (min-width: 1286px) and (max-height: 760px) and (max-width: 1440px) {
      top: 50px;
    }
    @media screen and (min-width: 1280px) and (max-width: 1660px) and (max-height: 775px) {
      top: 50px;
    }
    //@media screen and (min-width: 1500px) and (max-width: 1700px) and (max-height: 775px) {
    //
    //}
    //@media screen and (min-width: 1500px) and (max-width: 1700px) and (max-height: 775px) {
    //  margin-top: 80px;
    //}
  }
  @media screen and (max-height: 700px) and (min-width: 992px) and (max-width: 1150px){
    .container-slider-h {
      width: 100%;
      min-height: 455px;
    }
  }
  @media screen and (max-height: 720px) and (min-width: 1100px) {
    .container-slider-h {
      width: 100%;
      min-height: 460px;
    }
  }
  @media screen and (max-height: 721px) and (min-width: 1200px) {
    .container-slider-h {
      width: 100%;
      min-height: 485px;
    }
  }
  @media screen and (max-height: 721px) and (min-width: 1200px) {
    .container-slider-h {
      width: 100%;
      min-height: 485px;
    }
  }
  @media screen and (min-height: 600px)  and (max-height: 722px) and (min-width: 1250px) {
    .container-slider-h {
      width: 100%;
      min-height: 400px;
    }
  }

  @media screen and (max-height: 900px) and (min-width: 1920px) {
    .container-slider-h {
      width: 100%;
      min-height: 680px;
    }
  }

  .snow-holder {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    transition: opacity 2s ease-in-out;
    pointer-events: none;
    user-select: none;
    &.hidden {
      opacity: 0;
    }
  }
  .carousel-item.active {
    .layer--img {
      animation: pulse 2s infinite ease-in-out;
    }
  }
  @keyframes pulse {
    from {
      transform: none;
    }

    50% {
      -webkit-transform: scale(1.05, 1.05);
      transform: scale(1.05, 1.05);
    }
    to {
      transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue